import { SubmissionService } from "../../services/SubmissionService";
import React, { useState, useEffect, useCallback } from "react";
import * as APIModels from "../../models";

export default function SearchControl() {
    const [updatedSubmissions, setUpdatedSubmissions] = useState(
        [] as APIModels.Submission[]
    );
    const [updatedSearch, setUpdatedSearch] = useState("" as string);

    const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.stopPropagation();
        event.preventDefault();
        event.nativeEvent.stopImmediatePropagation();
        await SubmissionService.search({
            search: updatedSearch,
        }).then(
            (resp) => {
                if (resp?.successful === true && resp?.data) {
                    console.log(resp?.data);
                    setUpdatedSubmissions(resp?.data);
                } else {
                    console.log(resp?.errorMessage);
                }
            },
            (error) => {
                console.log(error);
            }
        );
    };

    const submissionItems = updatedSubmissions.map((submission) => {
        return (
            <a
                className="dropdown-item notify-item"
                href={`/reporting/submission/${submission?.id}`}
            >
                <i className="fe-home me-1" />
                <span className="text-wrap">{submission?.filename}</span>
                {console.log(submission?.id)}
            </a>
        );
    });

    return (
        <form
            className="app-search"
            style={{ width: "400px" }}
            onSubmit={(event) => {
                event.preventDefault();
                onSubmit(event);
            }}
        >
            <div className="app-search-box dropdown" style={{ width: "400px" }}>
                <div className="input-group" style={{ width: "400px" }}>
                    <input
                        type="search"
                        className="form-control"
                        placeholder="Search..."
                        id="top-search"
                        onChange={(event) => {
                            setUpdatedSearch(event.currentTarget.value);
                        }}
                    />
                    <button className="btn" type="submit">
                        <i className="fe-search"></i>
                    </button>
                    {updatedSubmissions && updatedSubmissions.length > 0 && (
                        <div
                            className="dropdown-menu dropdown-lg d-block"
                            id="search"
                            style={{ width: "400px" }}
                        >
                            {/* Start Dropdown */}
                            <div className="dropdown-header noti-title">
                                <h5 className="text-overflow mb-2">
                                    {/* prettier-ignore */}
                                    Found&nbsp;
                                    <span className="text-danger">
                                        {updatedSubmissions.length}
                                    </span>
                                    &nbsp;Submissions
                                </h5>
                            </div>
                            {/* Start Item List */}
                            {submissionItems}
                        </div>
                    )}
                </div>
            </div>
        </form>
    );
}
